import styled from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	ContainerDiv: CommonStyles.ContainerDiv,
	AreaDiv: CommonStyles.AreaDiv,
	SliderDiv: CommonStyles.SliderDiv,
	ContentImg: CommonStyles.ContentImg,
	TabDiv: CommonStyles.TabDiv,
	Tab: CommonStyles.Tab,
}

export default Style
